import {
  ROUTE_APPROVE_TIME_TIMESHEETS,
  ROUTE_QUERY_TIMESHEETS,
  ROUTE_TIMESHEETS,
  ROUTE_TIMESHEETS_REPORTS,
  TIME_APPROVAL_ADMIN_ACCESS,
  TIME_BASIC_ACCESS,
  TIME_VIEWER_AND_ADMIN_ACCESS,
  TIME_SUPER_ADMIN_ACCESS,
} from "../../SharedModule/utils/constants";
import { LeftNavBar } from "../../SharedModule/components/LeftNavBar";
import { LeftNavBarSection } from "../../SharedModule/components/LeftNavBarSection";
import { useSelector } from "react-redux";
import { selectUserRoles } from "../../SharedModule/redux/reducers/auth.reducer";

export const LeftNavBarTimesheets = () => {
  const { userRolesList } = useSelector(selectUserRoles);

  return (
    <LeftNavBar>
      <LeftNavBarSection
        mainTitle="Time"
        biIconName="BiAlarm"
        requireModuleAccess={false}
        actualUserRoles={userRolesList}
        listOfLinks={[
          {
            text: "Enter Time",
            route: ROUTE_TIMESHEETS,
            requireModuleAccess: false,
          },
          {
            text: "Approve time",
            route: ROUTE_APPROVE_TIME_TIMESHEETS,
            requireModuleAccess: true,
            roleRequired: TIME_APPROVAL_ADMIN_ACCESS,
          },
        ]}
      />
      <LeftNavBarSection
        mainTitle="Reports"
        biIconName="BiBarChartAlt2"
        requireModuleAccess={false}
        actualUserRoles={userRolesList}
        listOfLinks={[
          {
            text: "Query",
            route: ROUTE_QUERY_TIMESHEETS,
            requireModuleAccess: false,
          },
          {
            text: "Time Reports",
            route: ROUTE_TIMESHEETS_REPORTS,
            requireModuleAccess: true,
            roleRequired: TIME_VIEWER_AND_ADMIN_ACCESS,
          },
        ]}
      />
      <LeftNavBarSection
        mainTitle="Reimbursements"
        biIconName="BiDollar"
        requireModuleAccess={true}
        roleRequired={TIME_BASIC_ACCESS}
        actualUserRoles={userRolesList}
        listOfLinks={[
          {
            text: "Reimbursements",
            route:
              process.env.REACT_APP_ASUITE_BASE_URI +
              "/Timesheets/reimbreport.asp",
            requireModuleAccess: true,
            roleRequired: TIME_BASIC_ACCESS,
          },
          {
            text: "Expense Report",
            route:
              process.env.REACT_APP_ASUITE_BASE_URI +
              "/Timesheets/Expense_Report.asp",
            requireModuleAccess: true,
            roleRequired: TIME_BASIC_ACCESS,
          },
        ]}
      />
      <LeftNavBarSection
        mainTitle="Administration"
        biIconName="BiShieldQuarter"
        requireModuleAccess={true}
        roleRequired={TIME_SUPER_ADMIN_ACCESS}
        actualUserRoles={userRolesList}
        listOfLinks={[
          {
            text: "Nature of Expenses",
            route:
              process.env.REACT_APP_ASUITE_BASE_URI +
              "/Timesheets/TimeNatureExpenses.asp",
            requireModuleAccess: true,
            roleRequired: TIME_SUPER_ADMIN_ACCESS,
          },
        ]}
      />
    </LeftNavBar>
  );
};
